import { Box, Grid, TextField, FormHelperText, FormControl, Button, Snackbar } from "@mui/material";
import { Contact } from "../../../types/Contact";
import React, { useEffect, useState } from "react";
import { updateContactNotes } from "../../../services/connector";

function NotesTab({
    contact,
    onContactUpdate
}: {
    contact: Contact;
    onContactUpdate: (updatedContact: Contact) => void;
}) {
    const [notes, setNotes] = useState("");
    const [snackOpen, setSnackOpen] = useState(false);

    useEffect(() => {
        if (contact && contact.evaluation.notes) {
            setNotes(contact.evaluation.notes)
        } else {
            setNotes("");
        }

        return () => {
            setNotes("");
        }
    }, [contact]);

    const handleSaveNotes = async () => {
        if (contact) {
            const updatedContact = await updateContactNotes(contact, notes);
            onContactUpdate(updatedContact);
            setSnackOpen(true);
        }
    }

    return (
        <Box sx={{ p: 2}}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl variant="standard" fullWidth>
                        <TextField
                            placeholder="Enregistrez vos commentaires sur le candidat (1000 caractères max)"
                            multiline
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            minRows={4}
                        />
                        <FormHelperText id="component-helper-text">
                            Ces informations ne sont pas visibles par les candidats.
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button onClick={handleSaveNotes} variant="contained">Enregistrer</Button>
                </Grid>
            </Grid>
                            
            <Snackbar
                open={snackOpen}
                autoHideDuration={2500}
                onClose={() => setSnackOpen(false)}
                message="Note enregistrée"
            />
        </Box>
    );
}

export default React.memo(NotesTab, (prevProps, nextProps) => {
    return prevProps.contact.id === nextProps.contact.id;
});